import { render, staticRenderFns } from "./employeePanel.vue?vue&type=template&id=2a496be2&scoped=true"
import script from "./employeePanel.vue?vue&type=script&lang=js"
export * from "./employeePanel.vue?vue&type=script&lang=js"
import style0 from "./employeePanel.vue?vue&type=style&index=0&id=2a496be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a496be2",
  null
  
)

export default component.exports